// Shown above a Pending table once rows are checked: selected count plus
// Reject All / Approve All.
const BulkActionBar = ({ selectedCount, isProcessing, onApprove, onReject }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="d-flex justify-content-end align-items-center gap-2 mb-2">
      <span className="text-secondary me-2">{selectedCount} selected</span>
      <button
        type="button"
        className="btn btn-danger"
        disabled={isProcessing}
        onClick={onReject}>
        Reject All
      </button>
      <button
        type="button"
        className="btn btn-success"
        disabled={isProcessing}
        onClick={onApprove}>
        Approve All
      </button>
    </div>
  );
};

export default BulkActionBar;
